import React from "react";
import { capitalize } from "../helpers/helpers";

function FilterIndicator({ filter, onClick, isActive }) {
    if (!isActive) return null;
    return (
        <div className="bg-gray-200 w-fit flex items-center gap-2 py-1 px-4 rounded-2xl">
            <div className="flex flex-wrap gap-2">
                {filter.map((filterItem, index) => (
                    <div className=" whitespace-nowrap">
                        {capitalize(filterItem)}
                        {filter.length === index + 1 ? "" : ","}
                    </div>
                ))}
            </div>
            <i
                onClick={() => onClick()}
                className={`pi pi-times text-black md:ml-4 cursor-pointer`}
            />
        </div>
    );
}

export default FilterIndicator;
